import { DataService } from './core/data.service';
import { AusenciaTemporaria } from '../_models/AusenciaTemporariaModel';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AusenciaTemporariaService extends DataService {
    context = 'ausenciatemporaria';

    listarAusenciasCadastradas() {
        return this.getWithParams<any>(null);
    }

    cadastrarAusenciaTemporaria(ausenciatemporaria: AusenciaTemporaria) {
        return this.post<any>(null, ausenciatemporaria);
    }

    obterPorLoginUsuarioRecebedorDataFim(loginUsuarioRecebedor: string, dataFim: string) {
        return this.get<any>(`LoginUsuarioRecebedor/${loginUsuarioRecebedor}/DataFim/${dataFim}`);
    }

    obterPorLoginUsuarioDataInicioDataFim(loginUsuario: string, dataInicio: string, dataFim: string) {
        return this.get<any>(`LoginUsuario/${loginUsuario}/DataInicio/${dataInicio}/DataFim/${dataFim}`);
    }

    obterPorLoginUsuarioLoginUsuarioRecebedorDataFim(loginUsuario: string, loginUsuarioRecebedor: string, dataFim: string) {
        return this.get<any>(`LoginUsuario/${loginUsuario}/LoginUsuarioRecebedor/${loginUsuarioRecebedor}/DataFim/${dataFim}`);
    }

    obterPorLoginUsuarioLoginUsuarioRecebedorDataInicioDataFim(loginUsuario: string,
        dataInicio: string,
        loginUsuarioRecebedor: string,
        dataFim: string) {
        return this.get<any>(`LoginUsuario/${loginUsuario}
        /LoginUsuarioRecebedor/${loginUsuarioRecebedor}
        /DataInicio/${dataInicio}
        /DataFim/${dataFim}`);
    }

    excluirAusenciaTemporaria(id: number) {
        return this.delete(null, id);
    }
}
